import React from 'react'
import { Link } from 'react-router-dom';
import './footer.css';

import Logo from '../assets/nav/logo.png';

import Playstore from '../assets/rewardDesc/playstore.png';
import Qr from '../assets/rewardDesc/qr.png';

import Playstore2 from '../assets/rewardDesc/playstore2.png';
import Qr2 from '../assets/rewardDesc/qr2.png';

const footer = () => {
    return (
        <>
            <div className="hero-footer">
                <div className="container footer">
                    <div className="footer-logo btn-zoom" >
                        <Link to='/' className="text-decoration-none">
                            <img src={Logo} alt="" />
                            <p>Reward Pro</p>
                        </Link>
                    </div>
                    <div className="footer-links">
                        <ul >
                            <li className="btn-zoom"><Link to='/about'>About</Link></li>
                            <li className="btn-zoom"><Link to='/download'>Download</Link></li>
                            <li className="btn-zoom"><Link to='/privacy-policy'>Privacy Policy</Link></li>
                            <li className="btn-zoom"><Link to='/contact'>Contact us</Link></li>
                        </ul>
                        <div className="footer-download">
                            <img src={Qr2} alt="" className="btn-zoom"/>
                            <img src={Playstore2} alt="" className="btn-zoom"/>
                        </div>
                    </div>
                </div>
                <div className="copyright">
                    <p>© Copyright RewardPro 2023</p>
                </div>
            </div>
        </>
    )
}

export default footer
